const CrossCircleIcon = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 124 123'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='0.581055'
        width='122.838'
        height='122.838'
        rx='61.4189'
        fill='#FEEFEA'
      />
      <path
        d='M61.2399 54.5L83.7223 37.4973C85.2364 36.3522 87.363 36.4991 88.7053 37.8414C90.1042 39.2403 90.1969 41.478 88.9185 42.9878L70.4509 64.7995L87.3581 85.0861C88.4981 86.4539 88.4093 88.4647 87.1532 89.7267C85.9246 90.9612 83.9684 91.0858 82.593 90.0172L60.6915 73L40.9501 88.7672C39.3585 90.0385 37.0658 89.9106 35.6254 88.4702L35.509 88.3538C34.0123 86.8571 33.9407 84.4535 35.3455 82.8704L51.9625 64.145L35.825 41.3502C34.8622 39.9902 35.0132 38.1357 36.1832 36.9494C37.4586 35.6562 39.5199 35.5782 40.8894 36.7713L61.2399 54.5Z'
        fill='#344054'
      />
    </svg>
  );
};

export default CrossCircleIcon;
